import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SiteNav from "components/Redesign/SiteNav.js";
import SiteFooter from "components/Redesign/SiteFooter.js";
import Accordion from "components/Redesign/Accordion.js";
import heroImg from "assets/img/hero/faq-hero.jpg";
import biendliIcon from "assets/img/brand/biendli-icon.svg";

function Faq() {
  const { t } = useTranslation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rd">
      <SiteNav />

      <section className="page-shell">
        <div className="wrap">
          <div className="rd-section-no">{t("faq.Page label")}</div>
          <h1 className="page-shell-h1">{t("faq.Page title")}</h1>

          <div className="faq-layout">
            <div className="faq-hero">
              <img src={heroImg} alt="Biene im Gegenlicht auf einer Kleeblüte" />
            </div>

            <div className="faq-main">
              <Accordion>
                <Accordion.Item question={t("faq.Q1 question")}>
                  <p>{t("faq.Q1 answer")}</p>
                </Accordion.Item>
                <Accordion.Item question={t("faq.Q2 question")}>
                  <p>{t("faq.Q2 answer")}</p>
                </Accordion.Item>
                <Accordion.Item question={t("faq.Q3 question")}>
                  <p>
                    {t("faq.Q3 answer prefix")}
                    <Link to="/fuer-unternehmen">{t("faq.Q3 answer link")}</Link>
                    {t("faq.Q3 answer suffix")}
                  </p>
                </Accordion.Item>
                <Accordion.Item question={t("faq.Q4 question")}>
                  <p>{t("faq.Q4 answer")}</p>
                </Accordion.Item>
                <Accordion.Item question={t("faq.Q6 question")}>
                  <p>{t("faq.Q6 answer intro")}</p>
                  <p>{t("faq.Q6 answer lede")}</p>
                  <ul>
                    <li><strong>{t("faq.Q6 tip 1 label")}</strong> {t("faq.Q6 tip 1 body")}</li>
                    <li><strong>{t("faq.Q6 tip 2 label")}</strong> {t("faq.Q6 tip 2 body")}</li>
                    <li><strong>{t("faq.Q6 tip 3 label")}</strong> {t("faq.Q6 tip 3 body")}</li>
                  </ul>
                </Accordion.Item>
                <Accordion.Item question={t("faq.Q5 question")}>
                  <p>{t("faq.Q5 answer")}</p>
                </Accordion.Item>
              </Accordion>

              <div className="faq-closing-note">
                <img src={biendliIcon} alt="" className="faq-closing-note-icon" />
                <p>{t("faq.Closing note")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}

export default Faq;
